<template>
  <div v-if="rows.length" class="trend-indicator-block">
    <div
      v-for="(metric, index) in rows"
      :key="`${keyPrefix}-${metric.key || index}`"
      class="trend-indicator-row"
      :title="tooltip"
    >
      <span class="trend-metric-label">
        <span v-if="metric.icon" class="trend-metric-icon" :class="metric.iconTone">
          <i class="bi" :class="metric.icon"></i>
        </span>
        {{ metric.label }}:
      </span>
      <span>{{ metric.currentText }}</span>
      <span :class="['trend-arrow', getDirectionClass(metric.direction)]">
        {{ metric.arrow }}
      </span>
      <template v-if="metric.hasBaseline">
        <span>{{ metric.signedDeltaPct }}</span>
        <span class="text-muted" :title="tooltip">vs previous period</span>
      </template>
      <template v-else>
        <span class="text-muted" :title="tooltip">vs previous period (no baseline)</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrendIndicatorRows",
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    tooltip: {
      type: String,
      default: "Compared to previous period: N/A",
    },
    keyPrefix: {
      type: String,
      default: "trend",
    },
  },
  methods: {
    getDirectionClass(direction) {
      if (direction === "up") {
        return "trend-up";
      }

      if (direction === "down") {
        return "trend-down";
      }

      return "trend-flat";
    },
  },
};
</script>

<style scoped>
.trend-indicator-block {
  background: #ffffff;
  border: 1px dashed #ced4da;
  border-radius: 0.5rem;
  padding: 0.65rem 0.75rem;
  margin-bottom: 0.9rem;
}

.trend-indicator-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  font-size: 0.8rem;
  line-height: 1.35;
}

.trend-indicator-row + .trend-indicator-row {
  margin-top: 0.3rem;
}

.trend-metric-label {
  font-weight: 700;
}

.trend-metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 999px;
  margin-right: 0.28rem;
  font-size: 0.7rem;
  border: 1px solid transparent;
}

.trend-metric-icon-revenue {
  color: #0f766e;
  background: rgba(20, 184, 166, 0.16);
  border-color: rgba(20, 184, 166, 0.35);
}

.trend-metric-icon-photos {
  color: #1d4ed8;
  background: rgba(59, 130, 246, 0.14);
  border-color: rgba(59, 130, 246, 0.34);
}

.trend-arrow {
  font-weight: 700;
  min-width: 0.95rem;
  text-align: center;
}

.trend-up {
  color: #198754;
}

.trend-down {
  color: #dc3545;
}

.trend-flat {
  color: #6c757d;
}
</style>
